module.exports = __webpack_public_path__ + "img/aboc.783882dd.png";